<template>
  <div class="row">
    <div class="flex xs10 offset--xs1">
      <va-card title="用户基本信息">
        <div class="flex xs12 sm12">
          <div class="d-flex justify--end">
            <va-button
              outline
              color="primary"
              @click="$router.push({ name: 'listInterview', query: {uid: $route.params.uid}})">
              面试记录
            </va-button>
          </div>
        </div>

        <!-- 第一排信息 -->
        <div class="row">
          <div class="flex md4 sm6 xs12">
            <va-input v-model="basicInfo.nickname" label="姓名" disabled />
          </div>
          <div class="flex md4 sm6 xs12">
            <va-input v-model="basicInfo.uid" label="Uid" disabled />
          </div>
          <div class="flex md4 sm6 xs12">
            <va-input v-model="basicInfo.email" label="邮箱" disabled />
          </div>
          <div class="flex md4 sm6 xs12">
            <va-input v-model="basicInfo.registerTime" label="注册时间" disabled />
          </div>
          <div class="flex md4 sm6 xs12">
            <va-input v-model="subscription" label="订阅套餐" disabled />
          </div>
          <div class="flex md4 sm6 xs12">
            <va-input v-model="startTime" label="订阅开始时间" disabled />
          </div>
          <div class="flex md4 sm6 xs12">
            <va-input v-model="endTime" label="订阅结束时间" disabled />
          </div>
        </div>

        <!-- 第二排：Quota 和按钮 -->
        <div class="row" style="margin-top: 16px;">
          <div class="flex md3 sm3 xs12">
            <va-input
              v-model="basicInfo.quota"
              label="Quota（可修改）"
              type="number"
            />
          </div>
          <div class="flex md3 sm3 xs12 d-flex align-center" style="justify-content: flex-start;">
            <va-button color="primary" @click="updateQuota" size="small">
              更新Quota
            </va-button>
          </div>
        </div>

        <!-- 第三排：邀请人信息 -->
        <div class="row" style="margin-top: 16px;">
          <div class="flex md6 sm6 xs12">
            <va-input
              v-model="basicInfo.inviterUid"
              label="邀请人UID"
              disabled
            />
          </div>
          <div class="flex md6 sm6 xs12">
            <va-input
              v-model="basicInfo.inviterName"
              label="邀请人姓名"
              disabled
            />
          </div>
        </div>

      </va-card>
    </div>
    <div class="flex xs10 offset--xs1">
      <va-card title="最新面试设置">
        <div class="row">
          <div class="flex  xs12">
            <va-input
              v-model="preference.position"
              label="岗位"
              disabled
            />
          </div>
          <div class="flex  xs12">
            <va-input
              v-model="preference.stages"
              label="阶段"
              disabled
            />
          </div>
          <div class="flex  xs12">
            <va-input
              label="简历链接"
              v-model="preference.resumeUrl"
              disabled
            />
          </div>
          <div class="flex  xs12">
            <va-input
              label="JD"
              v-model="preference.jobDescription"
              disabled
              type="textarea"
              min-rows=10
            />
          </div>
          <div class="flex  xs12">
            <va-input
              label="面试流程"
              v-model="preference.resumeJdQuestion"
              disabled
              type="textarea"
              min-rows=10
            />
          </div>
        </div>
      </va-card>
    </div>
  </div>
</template>

<script>

import { copyObject, formatTime } from '@/utils/common'
    import interviewApi from '@/api/interview'

export default {
  data () {
    return {
      surveyShow: false,
      subscriptionShow: false,
      pushRecordShow: false,
      basicInfo: {
        uid: '',
        nickname: '',
        email: '',
        registerTime: 0,
        startTime: 0,
        endTime: 0,
        subscriptionType: 0,
        quota: 0,
        inviterUid: '',
        inviterName: '',
      },
      preference: {
        position: '',
        stages: '',
        resumeUrl: '',
        resumeJdQuestion: '',
        jobDescription: '',
      },
    }
  },
  created () {
    this.getUser()
  },
  computed: {
    subscription () {
      const status = this.basicInfo.subscriptionType
      if (status === 1) {
        return 'monthly_essential'
      } else if (status === 2) {
        return 'monthly_pro'
      } else if (status === 3) {
        return 'quarterly_essential'
      } else if (status === 4) {
        return 'quarterly_pro'
      } else {
        return 'free'
      }
    },
    startTime () {
      const startTime = this.basicInfo.startTime
      if (!startTime) { return '-' }
      return formatTime(startTime)
    },
    endTime () {
      const endTime = this.basicInfo.endTime
      if (!endTime) { return '-' }
      return formatTime(endTime)
    },
  },
  methods: {

    updateQuota () {
      if (this.basicInfo.quota == null || this.basicInfo.quota < 0) {
        this.showToast('Quota 不能为空或小于 0', {
          duration: 1000,
          icon: 'fa-warning',
          position: 'top-center'
        })
        return
      }

      interviewApi.updateQuota({
        uid: this.basicInfo.uid,
        quota: this.basicInfo.quota
      }).then(() => {
        this.showToast('Quota 更新成功', {
          duration: 1000,
          icon: 'fa-check',
          position: 'top-center'
        })
        // 更新成功后重新获取用户信息
        this.getUser()
      }).catch((error) => {
        this.showToast(`Quota 更新失败: ${error.msg}`, {
          duration: 1000,
          icon: 'fa-warning',
          position: 'top-center'
        })
      })
    },

    getUser () {
      const params = this.$route.params
      if (params.uid != null) {
        // 通过id获取详情
        interviewApi.getUser(params.uid).then(response => {
          copyObject(response, this.basicInfo)
          this.basicInfo.registerTime = formatTime(this.basicInfo.registerTime)
          // eslint-disable-next-line no-prototype-builtins
          if (response.hasOwnProperty('preferenceDTO')) {
            copyObject(response.preferenceDTO, this.preference)
          }
          // 查询邀请人姓名
          if (this.basicInfo.inviterUid) {
                  interviewApi.getUser(this.basicInfo.inviterUid)
                    .then(res => {
                      this.basicInfo.inviterName = res.nickname || '-'
                    })
                    .catch(() => {
                      this.basicInfo.inviterName = '(获取失败)'
                    })
          }
        }).catch(error => {
          this.showToast(error.msg, {
            duration: 1000,
            icon: 'fa-warning',
            position: 'top-center',
            fullWidth: false,
          })
        })
      }
    },
  },
}

</script>
